package com.daytimegaming.ourdailyfinances.domain.usecase

import com.daytimegaming.ourdailyfinances.domain.model.UserProfile
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository

class GetUserProfile(private val repo: UserRepository) {
    suspend operator fun invoke(): UserProfile = repo.getProfile()
}

class RegisterUserProfile(private val repo: UserRepository) {
    suspend operator fun invoke(): UserProfile = repo.registerProfile()
}

class UpdateUserProfile(private val repo: UserRepository) {
    suspend operator fun invoke(firstName: String?, lastName: String?): UserProfile =
        repo.updateProfile(firstName, lastName)
}

class UserUseCase(
    val GetUserProfile: GetUserProfile,
    val RegisterUserProfile: RegisterUserProfile,
    val UpdateUserProfile: UpdateUserProfile,
)
